<template>
  <div class="timeline-container padding-17-left-right">
    <h2 class="title">{{ createTitle }}</h2>

    <div :class="['timeline', userIsClient ? 'cliente' : 'no-cliente']">
      <ul :class="userIsClient ? 'cliente' : 'no-cliente'">
        <li v-for="(step, index) in timelineSteps" :key="index">
          <span class="circle">{{ index + 1 }}</span>
          <span class="text">{{ step }}</span>
        </li>
      </ul>

      <div class="offer-time">
        <h2>{{ disclaimerTimeline.title }}</h2>
        <p>{{ disclaimerTimeline.subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferTimeline",
  props: {
    userIsClient: Boolean,
    steps: Object,
    tituloTimeline: Object,
    disclaimerTimeline: Object
  },
  computed: {
    createTitle() {
      return this.userIsClient
        ? this.tituloTimeline.cliente
        : this.tituloTimeline.noCliente;
    },
    timelineSteps() {
      return this.userIsClient ? this.steps.cliente : this.steps.noCliente;
    }
  }
};
</script>

<style scoped>
div.timeline-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 8px 0;
  margin: 56px 0;
}

div.timeline-container h2.title {
  font-size: 36px;
  font-weight: 500;
  line-height: 40px;
  color: #121212;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif !important;
}
div.timeline {
  margin: auto;
}
div.timeline ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: auto;
}

div.timeline ul li {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 235px;
  padding: 4px 12px;
}
div.timeline ul li span {
  font-size: 15px;
}

div.timeline ul li span.text {
  white-space: wrap;
  text-align: center;
  display: -webkit-box;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  min-width: 220px;
  padding: 0 20px;
  color: #121212;
}
.title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.timeline-container h3 {
  font-size: 18px;
  color: #000;
  font-weight: bold;
  margin-top: 30px;
}

.timeline-container p {
  font-size: 14px;
  color: #555;
}

.timeline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin: 20px auto;
  max-width: 940px;
  width: 100%;
  position: relative;
  padding: 20px 0;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2.5px;
  z-index: 0;
  transform: translateY(-30px);
  width: 100%;
  max-width: 75%;
  margin: auto;
  background: linear-gradient(
    to right,
    #5ac4c4 40%,
    #5ac4c4 45%,
    #1464a5 55%,
    #1464a5 60%
  );
}
.timeline.cliente::before {
  top: 26%;
}
.timeline.no-cliente::before {
  top: 28%;
}
.timeline ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
  width: 100%;
  margin: 0;
}

.timeline li {
  position: relative;
  z-index: 1;
  text-align: center;
  flex: 1;
}

.circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #46c4d1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  font-size: 16px;
  font-weight: bold;
}

.timeline li:nth-child(2) .circle {
  background-color: #0b8ea8;
}

.timeline li:nth-child(3) .circle {
  background-color: #1e73b7;
}

.timeline li:nth-child(4) .circle {
  background-color: #094067;
}

div.offer-time {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 20px;
}

div.offer-time h2 {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif !important;
}
div.offer-time p {
  font-size: 16px;
  font-weight: 600;
  margin-top: 0px;
}

.timeline li span:last-child {
  font-size: 14px;
  color: #333;
  display: block;
  margin-top: 5px;
  max-width: 150px;
  margin-left: auto;
  margin-right: auto;
}

div.timeline-subtitle {
  margin-top: 20px;
  color: #121212;
}

div.timeline-subtitle p {
  font-size: 18px;
}

@media screen and (max-width: 600px) {
  div.timeline-container {
    padding: 0 20px !important;
    margin: 40px 0;
  }

  div.timeline {
    padding: 0;
    min-width: 340px !important;
  }

  div.timeline ul {
    flex-direction: column;
  }

  .timeline ul li,
  .timeline ul {
    width: 334px !important;
  }

  div.timeline-container h2.title {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
  }
  div.timeline ul li {
    flex-direction: row;
    max-width: unset;
    align-items: center !important;
    margin: 10px 0;
    padding: 0px;
  }
  div.timeline ul li span.text {
    text-align: left;
    padding: 0 !important;
    justify-content: unset;
    font-size: 12px;
    transform: translateX(-10px);
  }

  div.timeline .circle {
    margin: 0;
    width: 27px;
    height: 27px;
  }

  div.timeline-subtitle {
    width: 100%;
    margin-top: 10px;
  }
  div.timeline-subtitle p {
    font-size: 12px;
    text-align: left;
  }

  .timeline.no-cliente::before {
    top: 29%;
  }

  .timeline.cliente::before {
    max-width: 30%;
  }
  .timeline::before {
    -webkit-transform: rotate(90deg) translateY(153px);
    transform: rotate(90deg) translateY(153px);
    max-width: 37%;
    height: 1px;
  }

  div.offer-time h2,
  div.offer-time p {
    text-align: left;
  }
  div.offer-time h2,
  div.offer-time p,
  div.timeline ul li span.text {
    font-size: 12px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .timeline.no-cliente::before {
    max-width: 80%;
    top: 22%;
    width: 100%;
  }
  .timeline .no-cliente li {
    max-width: 150px;
  }

  .timeline .no-cliente li span.text {
    min-width: 125px;
  }

  .timeline-container h2.title {
    text-align: center;
  }

  .timeline::before {
    max-width: 82%;
  }
}

@media screen and (min-width: 963px) and (max-width: 1024px) {
  .timeline .no-cliente li {
    max-width: 250px;
  }

  .timeline.no-cliente::before {
    max-width: 76%;
    top: 26%;
  }

  .timeline.cliente::before {
    top: 27%;
    width: 72%;
  }
}

@media screen and (min-width: 523px) and (max-width: 600px) {
  .timeline.no-cliente::before {
    max-width: 32%;
  }
}

@media screen and (min-width: 600px) and (max-width: 768px) {
  .timeline.cliente::before {
    top: 26%;
    width: 70%;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .timeline.cliente::before {
    top: 27%;
    width: 72%;
  }
}

@media (min-width: 321px) and (max-width: 350px) {
  div.offer-time {
    max-width: 270px;
    margin-left: -50px;
  }
}

@media screen and (max-width: 320px) {
  div.timeline-container {
    padding: 0 10px !important;
  }
  div.timeline {
    min-width: unset !important;
  }
  .timeline.no-cliente::before {
    left: 11%;
    max-width: 50%;
  }
  div.timeline ul li span.text {
    -webkit-transform: translateX(-30px);
    transform: translateX(-30px);
  }
  .timeline.cliente::before {
    left: 12%;
  }
}

@media screen and (min-width: 600px) and (max-width: 768px) {
  .timeline.cliente::before {
    top: 26%;
    width: 70%;
  }
}
</style>
